(() => {
  const pathSegments = window.location.pathname.split('/').filter(Boolean);
  const blogsIndex = pathSegments.indexOf('blogs');
  const isWitchwire = blogsIndex !== -1 && pathSegments[blogsIndex + 1] === 'psychic-blog';
  if (!isWitchwire) return;

  const now = Date.now();
  const day = 86400000;
  const popup = document.querySelector('[data-ww-lead-popup]');
  const success = document.querySelector('[data-ww-lead-success]');
  const popupSuccess = popup ? popup.querySelector('[data-ww-lead-success]') : null;

  const readStoredTime = (key) => {
    try {
      return Number(localStorage.getItem(key) || 0);
    } catch (error) {
      return 0;
    }
  };

  const storeTime = (key, value) => {
    try {
      localStorage.setItem(key, String(value));
    } catch (error) {
      // Keep the popup functional even when storage is unavailable.
    }
  };

  const convertedAt = readStoredTime('wwLeadConvertedAt');
  const dismissedAt = readStoredTime('wwLeadDismissedAt');

  const inline = document.querySelector('[data-ww-lead-capture="inline"]');
  const articleBody = document.querySelector('[data-ww-article-body]');
  if (inline && articleBody && inline.parentElement === articleBody) {
    const candidates = [...articleBody.children].filter((el) =>
      el !== inline &&
      !el.matches('[data-ww-read-next], [data-ww-inline-offer]') &&
      !el.classList.contains('ww-lead-capture')
    );
    if (candidates.length >= 4) {
      const targetIndex = Math.min(candidates.length - 1, Math.max(2, Math.round(candidates.length * 0.32)));
      candidates[targetIndex].insertAdjacentElement('afterend', inline);
    }
  }

  let shown = false;
  let lastFocused = null;
  let scrollTriggered = false;
  let lockedScrollY = 0;
  let bodyStylesBeforeLock = null;

  const lockPageScroll = () => {
    if (!popup || document.documentElement.classList.contains('ww-lead-popup-open')) return;

    lockedScrollY = window.scrollY || document.documentElement.scrollTop || 0;
    const style = document.body.style;
    bodyStylesBeforeLock = {
      position: style.position,
      top: style.top,
      left: style.left,
      right: style.right,
      width: style.width,
      overflow: style.overflow,
    };

    document.documentElement.classList.add('ww-lead-popup-open');
    document.body.classList.add('ww-lead-popup-open');
    style.position = 'fixed';
    style.top = `-${lockedScrollY}px`;
    style.left = '0';
    style.right = '0';
    style.width = '100%';
    style.overflow = 'hidden';
  };

  const unlockPageScroll = () => {
    document.documentElement.classList.remove('ww-lead-popup-open');
    document.body.classList.remove('ww-lead-popup-open');

    if (bodyStylesBeforeLock) {
      Object.assign(document.body.style, bodyStylesBeforeLock);
      bodyStylesBeforeLock = null;
    }

    window.scrollTo(0, lockedScrollY);
  };

  const focusPopup = () => {
    if (!popup) return;
    const target = popupSuccess || popup.querySelector('[role="dialog"]');
    requestAnimationFrame(() => {
      if (target && typeof target.focus === 'function') target.focus();
    });
  };

  const showPopup = () => {
    if (!popup || shown || document.documentElement.classList.contains('ww-path-engaged')) return;
    shown = true;
    lastFocused = document.activeElement;
    popup.hidden = false;
    lockPageScroll();
    focusPopup();
  };

  const closePopup = () => {
    if (!popup || popup.hidden) return;
    popup.hidden = true;
    unlockPageScroll();

    if (!popupSuccess) {
      storeTime('wwLeadDismissedAt', Date.now());
    }

    if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
  };

  if (popup) {
    popup.querySelectorAll('[data-ww-lead-close]').forEach((button) => button.addEventListener('click', closePopup));

    document.addEventListener('keydown', (event) => {
      if (popup.hidden) return;

      if (event.key === 'Escape') {
        closePopup();
        return;
      }

      if (event.key !== 'Tab') return;

      const focusable = [...popup.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )].filter((element) => !element.hidden && element.getClientRects().length > 0);

      if (!focusable.length) {
        event.preventDefault();
        const dialog = popup.querySelector('[role="dialog"]');
        if (dialog) dialog.focus();
        return;
      }

      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
  }

  if (success) {
    storeTime('wwLeadConvertedAt', now);

    if (popupSuccess && popup) {
      shown = true;
      lastFocused = document.activeElement;
      popup.hidden = false;
      lockPageScroll();
      focusPopup();
    } else {
      requestAnimationFrame(() => success.focus());
    }
    return;
  }

  if (!popup || (convertedAt && now - convertedAt < 180 * day) || (dismissedAt && now - dismissedAt < 14 * day)) return;

  window.setTimeout(showPopup, 40000);

  const onScroll = () => {
    if (scrollTriggered) return;
    const root = document.documentElement;
    const available = Math.max(1, root.scrollHeight - window.innerHeight);
    if (window.scrollY / available >= 0.5) {
      scrollTriggered = true;
      showPopup();
      window.removeEventListener('scroll', onScroll);
    }
  };
  window.addEventListener('scroll', onScroll, { passive: true });

  if (window.matchMedia('(min-width: 990px)').matches) {
    document.addEventListener('mouseout', (event) => {
      if (!event.relatedTarget && event.clientY <= 8) showPopup();
    });
  }
})();